import { defineGameCard } from '../authoring/index.js';
export const ColonyAttackBonusCard = defineGameCard({
    id: 'colony_attack_bonus',
    gameplay: { type: 'EFFECT', cost: 0 },
    presentation: {
        name: 'Колония',
        description: 'Колониальный хищник получает +4 к атаке, пока в его локации есть ещё хотя бы два ваших слизня.',
        glyph: {
            colors: ['#2E5E3A', '#6BCF5E', '#F0E45E'],
            rows: [
                '....3....',
                '...333...',
                '..33333..',
                '....3....',
                '.........',
                '.2..2..2.',
                '.2222222.',
                '222222222',
                '.1111111.',
            ],
        },
    },
    role: 'auxiliary',
});
//# sourceMappingURL=colony_attack_bonus.js.map